import React from 'react';
import { useAppSelector } from '../../redux/hooks';
import { closedCaptionsSelector } from '../../redux/slices/closedCaptions';
import { ccSelector } from '../../redux/slices/ui';
export default function ClosedCaptions() {
    const captionsEnabled = useAppSelector(ccSelector);
    const captions = useAppSelector(closedCaptionsSelector);
    if (!captionsEnabled || captions.length === 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "closedcaption-container" }, captions.map((text) => (React.createElement("div", { key: text, className: "closedcaption-text" }, text)))));
}
//# sourceMappingURL=ClosedCaptions.js.map